import React from "react";
import { ARE_YOU_SHURE_TITLE} from "../i18n/i18n";
import {confirmAlert} from "react-confirm-alert";
import PropTypes from "prop-types";

export const GenericConfirmAlert = ({
                                        dataRequest,
                                  method,
                                  closeOnEscape= true,
                                  closeOnClickOutside= true,
                              })  => {
    return confirmAlert({
        closeOnEscape,
        closeOnClickOutside,
        customUI: ({onClose}) => {
            return (
                <div className='custom-ui'>
                    <h1>{ ARE_YOU_SHURE_TITLE }</h1>
                    <p>{ 'Debe confirmar la ejecución del proceso' }</p>
                    <button onClick={onClose}>{'No'}</button>
                    <button className={"btn-alert-delete"} onClick={() => {
                        method(dataRequest);
                        onClose();
                    }}>
                        {'Si, Confirmar'}
                    </button>
                </div>
            );
        }
    });
};

GenericConfirmAlert.propTypes = {
};